import { Box, BoxProps } from '@mui/material';

export const Spacer = ({ sx, ...props }: BoxProps) => <Box sx={{ flexGrow: 1, ...sx }} {...props} />;
